import getLocale from './getLocale';
import esTranslations from '../locales/es';

export default function t(key: string) {
  if (getLocale() === 'es' && esTranslations[key as keyof typeof esTranslations]) {
    return esTranslations[key as keyof typeof esTranslations];
  }

  return key;
}
